import logoTesouro from 'ksk/assets/template/tesouro-bg-transparente-1.svg';
import KskBoxBody from 'ksk/styledComponents/components/KskBox/KskBoxBody';
import KskBoxFooter from 'ksk/styledComponents/components/KskBox/KskBoxFooter';
import KskBoxHeader from 'ksk/styledComponents/components/KskBox/KskBoxHeader';
import React from 'react';
import { S } from './Home.styles';

function Home() {
  return (
    <S.KskBox highlight>
      <KskBoxHeader  className="home__header">
        <img className="home__logo-tesouro" src={logoTesouro} alt="Logo do Tesouro Nacional"/>
        <div>
          <h3 className="home__apresentacao">Apresentação</h3>
          <div className="home__siconfi-small">
            <span className="bold">Siconfi - </span>
            <span> Sistema de Informações Contábeis e Fiscais do Setor Público Brasileiro</span>
          </div>
        </div>
      </KskBoxHeader>
      <KskBoxBody className="home__body">
        <h3>Operações de Crédito para Estados e Municípios</h3>
        <div className="home__text-columns">
          <p>
            A contratação de operações de crédito, por Estados, Distrito Federal e Municípios, 
            incluindo suas Autarquias, Fundações e Empresas Estatais Dependentes, subordina-se às
            normas da Lei Complementar nº 101, de 04/05/2000 (Lei de Responsabilidade Fiscal – LRF)
            e às Resoluções do Senado Federal (RSF) nº 40 e 43, de 2001.
          </p>
          <p>
            O Manual para Instrução de Pleitos (MIP), aprovado por portaria da Secretaria do 
            Tesouro Nacional, regulamenta os procedimentos de instrução dos pedidos de 
            verificação de limites e condições. Pretende-se, igualmente, orientar, de forma objetiva 
            e didática, as prefeituras e governos estaduais quanto aos dispositivos legais e o 
            adequado fornecimento das informações necessárias para a análise das propostas.
          </p>
          <p>
            A garantia da União pode ser concedida em operações de crédito de prefeituras e
            governos estaduais, e deve atender aos limites e condições previstos na Resolução do Senado 
            Federal nº 48/2007 e no art. 40 da Lei de Responsabilidade Fiscal. 
          </p>
          <p>
            As operações externas de órgãos e entidades do setor público dependem de registro e 
            credenciamento prévio no Banco Central do Brasil, bem como da autorização do Senado Federal.
          </p>
          <p>
            Em abril de 2015, o Tesouro lançou o Sistema de Análise da Dívida Pública, Operações de 
            Crédito e Garantias da União, Estados e Municípios (SADIPEM), disponível 
            em <a href="http://sadipem.tesouro.gov.br" rel="noopener noreferrer" target="_blank">sadipem.tesouro.gov.br</a>,
            que permite o envio de pedidos de verificação de limites e condições relativos à contratação de 
            operação de crédito e de concessão de garantias da União, Estados, Distrito Federal e Municípios.
          </p>
        </div>
      </KskBoxBody>
      <KskBoxFooter>&nbsp;</KskBoxFooter>
    </S.KskBox>
  )
}

export default Home;
